import React from 'react';
import { Redirect, Route, withRouter } from 'react-router';
import * as Routes from '../../app/_constants/routes';
import SalesforceIntegrationPage from './salesforceIntegrationPage/salesforceIntegrationPage.view';
import IAppIntegrationPage from './iAppIntegrationPage/iAppIntegrationPage';
import HubspotIntegrationPage from './huspotIntegrationPage/hubspotIntegrationPage';
import NotificationsPage from './notificationsPage';
import ViewsPage from './viewsPage';
import DialersPage from './dialersPage/dialersPage';
import DependenciesPage from './dependenciesPage';
import UsersPage from './usersPage/usersPage';
import GeneralSettingsPage from './generalSettingsPage/generalSettingsPage';
import { FieldsPage } from './fieldsPage/fieldsPage';
import { ROUTES_TO_MAP } from './accountSettingsPages.old.routes';
import ChromeExtensionPage from './chromeExtensionPage/chromeExtensionPage';
import DynamicsIntegrationPage from './dynamicsIntegrationPage';
import VtigerIntegrationPage from './vtigerIntegrationPage';
import { useDynamicsEnabled, useVtigerEnabled } from '../../hooks/useFeatureFlags';
import EmailSettingsPage from './emailSettingsPage/emailSettingsPage';
import { ApiKeyPage } from './apiKeyPage/pages/apiKeyPage';

const RoutesComponent = () => {
  const isDynamicsEnabled = useDynamicsEnabled();
  const isVtigerEnabled = useVtigerEnabled();
  return (
    <>
      <Route
        exact
        path={Routes.APP_ACCOUNT_INTEGRATION_SALESFORCE_TAB}
        component={SalesforceIntegrationPage}
      />
      <Route
        exact
        path={Routes.APP_ACCOUNT_INTEGRATION_SALESFORCE_MAPPING_NAME}
        component={SalesforceIntegrationPage}
      />
      <Route
        exact
        path={Routes.APP_ACCOUNT_INTEGRATION_HUBSPOT_TAB}
        component={HubspotIntegrationPage}
      />
      <Route exact path={Routes.APP_ACCOUNT_NOTIFICATIONS} component={NotificationsPage} />
      {isDynamicsEnabled && (
        <Route path={Routes.APP_ACCOUNT_INTEGRATION_DYNAMICS_TAB}>
          <DynamicsIntegrationPage />
        </Route>
      )}
      {isVtigerEnabled && (
        <Route path={Routes.APP_ACCOUNT_INTEGRATION_VTIGER_TAB}>
          <VtigerIntegrationPage />
        </Route>
      )}
      <Route path={Routes.APP_ACCOUNT_INTEGRATION_API_KEY}>
        <ApiKeyPage />
      </Route>
      <Route
        path={Routes.integrationURLs().APP_ACCOUNT_INTEGRATIONAPP_CONNECTOR_TAB}
        component={IAppIntegrationPage}
      />
      <Route exact path={Routes.APP_ACCOUNT_SALES_TEAM} component={UsersPage} />
      <Route exact path={Routes.APP_ACCOUNT_GENERAL_SETTINGS} component={GeneralSettingsPage} />
      <Route exact path={Routes.APP_ACCOUNT_FIELD_DEPENDENCIES} component={DependenciesPage} />
      <Route exact path={Routes.APP_ACCOUNT_VIEWS} component={ViewsPage} />
      <Route exact path={Routes.APP_ACCOUNT_DIALERS_TWILIO}>
        <DialersPage tab="Twilio" />
      </Route>
      <Route exact path={Routes.APP_ACCOUNT_DIALERS_AIRCALL}>
        <DialersPage tab="Aircall" />
      </Route>
      <Route exact path={Routes.APP_ACCOUNT_DIALERS_JUSTCALL}>
        <DialersPage tab="JustCall" />
      </Route>
      <Route exact path={Routes.APP_ACCOUNT_DIALERS_AIRCALL_REDIRECT}>
        <DialersPage tab="Aircall" />
      </Route>
      <Route exact path={Routes.APP_ACCOUNT_DIALERS}>
        <DialersPage tab="Twilio" />
      </Route>
      <Route exact path={Routes.APP_ACCOUNT_EMAILS}>
        <EmailSettingsPage />
      </Route>
      <Route exact path={Routes.APP_ACCOUNT_FIELDS}>
        <FieldsPage tab="Fields" />
      </Route>
      <Route exact path={Routes.APP_ACCOUNT_GLOBAL_PICKLISTS}>
        <FieldsPage tab="Global Picklists" />
      </Route>
      <Route exact path={Routes.APP_ACCOUNT_GROUPS}>
        <FieldsPage tab="Groups" />
      </Route>
      <Route exact path={Routes.APP_ACCOUNT_CHROME_EXTENSION}>
        <ChromeExtensionPage />
      </Route>
      {/* REDIRECTS OLD URLS */}
      {Object.keys(ROUTES_TO_MAP).map(route => (
        <Route
          key={route}
          exact
          path={route}
          render={() => {
            const urlSearchParams = new URLSearchParams(window.location.search);
            return <Redirect to={`${ROUTES_TO_MAP[route]}/?${urlSearchParams.toString()}`} />;
          }}
        />
      ))}
    </>
  );
};

export default withRouter(RoutesComponent);
